enum RAMQDispensateurClass {
    Doctor = "1",
    Resident = "5",
    IPS = "8"
}

export { RAMQDispensateurClass };
